import React, { useState, useEffect } from "react";
import withRouter from "../../../../Components/Common/withRouter";
import { Card, CardBody, Col, Row,Alert } from "reactstrap";
import { subscribeToTokenRefresh } from "../../../../helpers/Refreshfile";
import { blogStatsDataType } from "./type";
import axios from "axios";

interface StatCard {
  title: string;
  value: string | number;
  icon: string;
}

// Helper function to format the stats data
const blogStatsData = (data: any): StatCard[] => [
  { title: 'Total Payment', value: "$ " + data.t_payment || 0, icon: 'bx bx-dollar' },
  { title: 'Total Expert', value: data.exp_count || 0, icon: 'bx bx-user' },
  { title: 'Total Customers', value: data.cus_count || 0, icon: 'bx bx-user-circle' },
  { title: 'Total Bookings', value: data.bking_count || 0, icon: 'bx bx-calendar' },
  { title: 'Completed Bookings', value: data.complete_count || 0, icon: 'bx bx-calendar-check' },
  { title: 'Revenue This Month', value: "$ " + data.monthly_revenue || 0, icon: 'bx bx-line-chart' },
];

const TopCards = () => {
  const [stats, setStats] = useState<StatCard[]>([]);


  const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
    const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false })
    };
    const [showloader, setshowloader] = useState(true);



  useEffect(() => {
    const fetchAdmin = async () => {
      // const userId = localStorage.getItem("authUser");
      // const user_role = localStorage.getItem("userole_");
      // { user_id: userId, user_role: user_role },

      try {
        const loaderElement = document.querySelector('.loaderWeb') as HTMLElement;
        if (loaderElement) loaderElement.style.display = 'flex';
        setshowloader(true)
        const response = await axios.post(`/accounts/admin_dashboard_details`,
          {
            withCredentials: true,
            headers: { 'Content-Type': 'application/json' },
          }
        );

        if (response.status === "admin_details") {
          setshowloader(false)
          
          const data = response;
          const formattedStats = blogStatsData(data);

          setStats(formattedStats);
        }

        if (loaderElement) loaderElement.style.display = 'none';
      } catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
              console.log('Error in stripe payment')
              setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
            }
            else if (error.response.status === 403) {
              console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
              console.log('An error occurred')
              setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
            }
        } else {
          console.log('An error occurred')
          setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
        }
        setshowloader(false)
    }
    };

    fetchAdmin();
    subscribeToTokenRefresh(() => {
      console.log("🔁 Token refreshed. Re-fetching experts...");
      fetchAdmin();
    });
  }, []);

  return (
    <React.Fragment>
      <Col lg={8}  className="order-lg-1 order-2">
      {alertMsgg.open && (
            <Alert
            color={alertMsgg.type === "success" ? "success" : "danger"}
            toggle={handleAlertMsggClose}
            style={{ fontWeight: "bold" }}
            >
            {alertMsgg.content}
            </Alert>
            )}
            <div className="loaderContainer" hidden={!showloader}>
            <div className="spinner">
              <div></div>  
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
            </div>
          </div>
        <Row>
          {stats.map((stat, index) => (
            <Col lg={4} key={index}>
              <Card className="blog-stats-wid rounded-4">
                <CardBody className="py-4">
                  <div className="d-flex flex-wrap py-2">
                    <div className="me-2">
                      <p className="text-muted mb-2 font-size-13">{stat.title}</p>
                      <h5 className="mb-0">{stat.value}</h5>
                    </div>
                    <div className="avatar-sm ms-auto">
                      <div className="avatar-title bg-light rounded-circle text-dark font-size-20">
                        <i className={stat.icon}></i>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Col>
    </React.Fragment>
  );
};

export default withRouter(TopCards);